import { render, staticRenderFns } from "./userTerminal.vue?vue&type=template&id=becceace&scoped=true&"
import script from "./userTerminal.vue?vue&type=script&lang=js&"
export * from "./userTerminal.vue?vue&type=script&lang=js&"
import style0 from "./userTerminal.vue?vue&type=style&index=0&id=becceace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becceace",
  null
  
)

export default component.exports